import { createContext, useContext, useState, useEffect } from 'react';
import { getUserData, setUserData as persistUserData, clearUserData, refreshUserProfile } from '../Dashboard/dashboardService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loadUser = async () => {
      const stored = getUserData();
      if (!stored?.access_token) {
        if (stored) setUser(stored);
        return;
      }
      const refreshed = await refreshUserProfile();
      setUser(refreshed);
    };
    loadUser();
  }, []);

  const setUserAndPersist = (data) => {
    if (data) {
      persistUserData(data);
      setUser(data);
    } else {
      clearUserData();
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser: setUserAndPersist }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
